export const TENANT_OPEN_NETWORK_CATEGORIES_RESET_STATE = 'TENANT_OPEN_NETWORK_CATEGORIES_RESET_STATE';
export const TENANT_OPEN_NETWORK_CATEGORIES_CURRENT_ITEM = 'TENANT_OPEN_NETWORK_CATEGORIES_CURRENT_ITEM';

export const TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_LOADING = 'TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_LOADING';
export const TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_SUCCESS = 'TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_SUCCESS';
export const TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_FAILED = 'TENANT_OPEN_NETWORK_CATEGORIES_REQUEST_FAILED';

export const TENANT_OPEN_NETWORK_CATEGORIES_CURRENT_ACTION = 'TENANT_OPEN_NETWORK_CATEGORIES_CURRENT_ACTION';
export const TENANT_OPEN_NETWORK_CATEGORIES_RESET_ACTION = 'TENANT_OPEN_NETWORK_CATEGORIES_RESET_ACTION';